var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBottomGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8383_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123 61.4998C123 95.4653 95.4657 123 61.5002 123C27.5347 123 0.000199471 95.4653 0.000199471 61.4998C0.000199471 27.5343 27.5347 -0.000164214 61.5002 -0.000164214C95.4657 -0.000164214 123 27.5343 123 61.4998Z",
    fill: "#7FFAA1",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8164 55.7566L51.7707 73.2208C54.5259 75.6464 58.1896 77 62 77C65.8104 77 69.4741 75.6464 72.2293 73.2208L91.1836 55.7566C92.3466 54.6848 93 53.2311 93 51.7153C93 50.1995 92.3466 48.7458 91.1836 47.674C90.0206 46.6021 88.4432 46 86.7984 46C85.1536 46 83.5762 46.6021 82.4132 47.674L63.459 65.1419C63.0714 65.499 62.5459 65.6995 61.9979 65.6995C61.45 65.6995 60.9244 65.499 60.5369 65.1419L41.5868 47.674C40.4238 46.6021 38.8464 46 37.2016 46C35.5568 46 33.9794 46.6021 32.8164 47.674C31.6534 48.7458 31 50.1995 31 51.7153C31 53.2311 31.6534 54.6848 32.8164 55.7566Z",
    fill: "#7FFAA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8383_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomGreen);
export default __webpack_public_path__ + "static/media/arrow-bottom-green.419f0f07d9f66e7419365a3e979622f0.svg";
export { ForwardRef as ReactComponent };